// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"55097819","379":"55097819","730":"55097819"}[chunkId] + ".chunk.css";
};